import React from "react";
import HotlineImage from "../../Assets/SampleHotline.png";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles((theme) => ({
  hotlineCard: {
    padding: 10,
    marginTop: 20,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.contrastText,
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
  },
  link: {
    color: theme.palette.common.white,
  },
}));

const HotlineCard = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.hotlineCard}>
      <Grid
        container
        spacing={3}
        direction="column"
        justify="space-around"
        alignItems="flex-start"
      >
        <Grid item lg={12}>
          <Typography component="div">
            <Box component="h1" display="block" m={1} letterSpacing={0.61}>
              HOTLINES
            </Box>
            <Box display="flex" justifyContent="center" m={1}>
              <img
                src={HotlineImage}
                alt="Current Hotline"
                height="100%"
                width="100%"
              />
            </Box>
          </Typography>
        </Grid>
        <Grid item lg={12}>
          <Typography component="div">
            <Box display="block" m={1} fontWeight={380} fontSize={24}>
              <Link
                href="https://redcross.org.ph/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                Red Cross
              </Link>
            </Box>
            <Box display="block" p={3} fontSize={18}>
              143
            </Box>
            <Box display="block" p={3} fontSize={18}>
              (02) 8527-8385 to 95
            </Box>
          </Typography>
        </Grid>
        <Grid item lg={12}>
          <Typography component="div">
            <Box display="block" m={1} fontWeight={380} fontSize={24}>
              <Link
                href="https://www.dilg.gov.ph/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                DEPARTMENT OF INTERIOR AND LOCAL GOVERNMENT (DILG)
              </Link>
            </Box>
            <Box display="block" p={3} fontSize={18}>
              (02) 8876-3454
            </Box>
          </Typography>
        </Grid>
        <Grid item lg={12}>
          <Typography component="div">
            <Box display="block" m={1} fontWeight={380} fontSize={24}>
              <Link
                href="http://www.pnp.gov.ph/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                PHILIPPINE NATIONAL POLICE (PNP)
              </Link>
            </Box>
            <Box display="block" p={3} fontSize={18}>
              117
            </Box>
            <Box display="block" p={3} fontSize={18}>
              (02) 8722-0650
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default HotlineCard;
